<template>
  <ReturnInvoiceDataTable ref="returnInvoiceDataTable"
                          :loading="loading"
                          :invoices="invoices"
                          :invoices-total="invoicesTotalCount"

                          :start-default-value="defaultValue.start"
                          :end-default-value="defaultValue.end"
                          :branch-default-value="defaultValue.branch"
                          :is-executor-approved-default-value="defaultValue.isExecutorApproved"
                          :is-customer-approved-default-value="defaultValue.isCustomerApproved"
                          :search-default-value="defaultValue.search"
                          :page-default-value="defaultValue.page"
                          :limit-default-value="defaultValue.limit"
                          :sort-default-value="defaultValue.sort"
                          :desc-default-value="defaultValue.desc"
                          :order-default-value="defaultValue.order"

                          :dialog="dialog"
                          :dialog-value="dialogValue"

                          @update="onUpdate"
                          @print="onPrint"
                          @excel-single="onExcelSingleDownload"
                          @excel-all="onExcelAllDownload"
                          @excel-all-items="onExcelAllItemsDownload"

  >
    <template v-slot:title>
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>Возвратные счёт-фактуры</v-toolbar-title>
        <v-spacer/>
      </v-toolbar>
    </template>
  </ReturnInvoiceDataTable>
</template>

<script>
import ReturnInvoiceDataTable from "@/components/DataTables/ReturnInvoiceDataTable";
import ReturnInvoiceBoxMixin from "@/views/main/return-invoice/box/ReturnInvoiceBoxMixin";

export default {
  name: "ReturnInvoiceAllBoxView",
  mixins: [ReturnInvoiceBoxMixin],
  components: {
    ReturnInvoiceDataTable
  }
}
</script>

<style scoped>

</style>